import { render, staticRenderFns } from "./FutureLayerImageBrowser.vue?vue&type=template&id=2d63e865&"
import script from "./FutureLayerImageBrowser.vue?vue&type=script&lang=ts&"
export * from "./FutureLayerImageBrowser.vue?vue&type=script&lang=ts&"
import style0 from "./FutureLayerImageBrowser.vue?vue&type=style&index=0&id=2d63e865&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports